import { render, staticRenderFns } from "./CatchsElaborateBoxes.vue?vue&type=template&id=b911a0e2"
import script from "./CatchsElaborateBoxes.vue?vue&type=script&lang=js"
export * from "./CatchsElaborateBoxes.vue?vue&type=script&lang=js"
import style0 from "./CatchsElaborateBoxes.vue?vue&type=style&index=0&id=b911a0e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports